<template>
  <div>
    <!--轮播图-->
    <div class="LunContent">
      <Carousel
        autoplay
        :autoplay-speed="3000"
        loop
        v-model="CarouselVal"
        :radius-dot="true"
      >
        <CarouselItem>
          <img src="../../static/img/home/1.jpg" alt="#" />
        </CarouselItem>
        <CarouselItem>
          <img src="../../static/img/home/2.jpg" alt="#" />
        </CarouselItem>
        <CarouselItem>
          <img src="../../static/img/home/3.jpg" alt="#" />
        </CarouselItem>
      </Carousel>
    </div>
    <!--新闻资讯-->
    <div class="news_div">
      <Row justify="center" type="flex">
        <Col :xs="24" :lg="15" :xl="15">
          <div style="margin-top: 40px">
            <div class="product_div01">新闻资讯</div>
            <div class="product_div02">NEWS</div>
          </div>
        </Col>
      </Row>
      <Row justify="center" type="flex">
        <Col :xs="22" :md="22" :lg="15" :xl="15">
          <Row justify="center" type="flex">
            <Col
              :xs="22"
              :md="22"
              :lg="11"
              :xl="11"
              class="news_hover"
              v-for="(item, index) in ulList"
              :key="index"
            >
              <div class="news_ul_div" @click="getSkip(item.name)">
                <div class="news_ul_li_div">
                  <p>{{ item.day }}</p>
                  <span>{{ item.month }}</span>
                </div>
                <div class="news_ul_li_div01">
                  <p>
                    {{ item.title }}
                  </p>
                  <span>{{ item.content }}</span>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row justify="center" type="flex">
        <Col :xs="24" :lg="15" :xl="15" style="margin-bottom: 30px">
          <div class="news_more">
            <div class="news_hr" @click="getLocalNews">
              <span>查看更多</span>
            </div>
            <div>
              <hr />
            </div>
          </div>
        </Col>
      </Row>
    </div>
    <!--  智慧工地  -->
    <!-- <div class="WisdomSite">
      <Row justify="center" type="flex" style="background: #ffffff">
        <Col span="15">
          <div style="margin: 20px 0 0 0">
            <div class="product_div01">智慧工地</div>
            <div class="product_div02">SOLUTIONS</div>
          </div>
        </Col>
        <Col span="20">
          <img
            style="width: 100%"
            src="../../static/img/WisdomSite/WisdomSiteImg.png"
            alt="#"
          />
        </Col>
        <Col span="5">
          <div class="WisdomSite_more" @click="WisdomSiteMore">
            <span>查看更多</span>
          </div>
        </Col>
      </Row>
    </div> -->
    <!--企业产品-->
    <div style="background: #ffffff" class="desktop">
      <Row justify="center" type="flex" style="background-color: #ffffff">
        <Col span="16" style="text-align: center">
          <div style="margin: 40px 0 20px 0">
            <div class="product_div01">企业产品</div>
            <div class="product_div02">Enterprise products</div>
          </div>
        </Col>
      </Row>
      <Row justify="center" type="flex" style="margin-top: 20px">
        <!--   电脑端   -->
        <Col :xs="0" :md="0" :lg="14" :xl="14" style="margin: 0 0 10px 10px">
          <Tabs value="name3">
            <TabPane label="智慧消防区" name="name3">
              <Row justify="start" type="flex">
                <Col
                  class="buy_col01"
                  v-for="(item, index) in photoArr2"
                  :key="index"
                >
                  <div class="buy_rule" @click="getMoney(item)">
                    <img :src="item.photoUrl" alt="#" />
                  </div>
                  <div @click="getMoney(item)" class="sp">{{ item.ref }}</div>
                  <div
                    style="font-size: 18px; color: #f12344; margin-bottom: 6px"
                  ></div>
                </Col>
              </Row>
            </TabPane>
            <TabPane label="VR/MR" name="name1">
              <Row justify="start" type="flex">
                <Col
                  class="buy_col01"
                  v-for="(item, index) in photoArr1"
                  :key="index"
                >
                  <div class="buy_rule" @click="skipVR(item)">
                    <img :src="item.photoUrl" alt="#" />
                  </div>
                  <div @click="skipVR(item)" class="sp">{{ item.ref }}</div>
                  <div
                    style="font-size: 18px; color: #f12344; margin-bottom: 6px"
                  ></div>
                </Col>
              </Row>
            </TabPane>
            <TabPane label="智能展示区" name="name8">
              <Row justify="start" type="flex">
                <Col
                  class="buy_col01"
                  v-for="(item, index) in photoArr3"
                  :key="index"
                >
                  <div class="buy_rule" @click="skipSafetyEducation(item)">
                    <img :src="item.photoUrl" alt="#" />
                  </div>
                  <div @click="skipSafetyEducation(item)" class="sp">
                    {{ item.ref }}
                  </div>
                  <div
                    style="font-size: 18px; color: #f12344; margin-bottom: 6px"
                  ></div>
                </Col>
              </Row>
            </TabPane>
          </Tabs>
        </Col>
        <!--    手机端    -->
        <Col :xs="22" :sm="22" :lg="0" :xl="0" class="tabs">
          <Tabs>
            <TabPane label="VR">
              <Row justify="start" type="flex">
                <Col :xs="11" :sm="11" :lg="0" :xl="0" class="tabs_vr">
                  <div @click="skipSafetyEducation">
                    <img
                      src="../../static/img/photo/photo_robot.jpg"
                      alt="暂无照片"
                    />
                    <p>智能机器人</p>
                  </div>
                </Col>
                <Col :xs="11" :sm="11" :lg="0" :xl="0" class="tabs_vr">
                  <div @click="skipSafetyEducation">
                    <img
                      src="../../static/img/photo/photo_jiaoyu.png"
                      alt="暂无照片"
                    />
                    <p>教育考试系统</p>
                  </div>
                </Col>
                <Col :xs="11" :sm="11" :lg="0" :xl="0" class="tabs_vr">
                  <div @click="skipSafetyEducation">
                    <img
                      src="../../static/img/photo/photo_anquan.png"
                      alt="暂无照片"
                    />
                    <p>安全隐患检查系统</p>
                  </div>
                </Col>
                <Col :xs="11" :sm="11" :lg="0" :xl="0" class="tabs_vr">
                  <div @click="skipSafetyEducation">
                    <img
                      src="../../static/img/photo/photo_biaoshi.png"
                      alt="暂无照片"
                    />
                    <p>安全标识识别系统</p>
                  </div>
                </Col>
                <Col :xs="11" :sm="11" :lg="0" :xl="0" class="tabs_vr">
                  <div @click="skipSafetyEducation">
                    <img
                      src="../../static/img/Buy/BodyFeel/BodyFeel02.png"
                      alt="暂无照片"
                    />
                    <p>体感式语音标识系统</p>
                  </div>
                </Col>
                <Col :xs="11" :sm="11" :lg="0" :xl="0" class="tabs_vr">
                  <div @click="skipSafetyEducation">
                    <img
                      src="../../static/img/Buy/Answer/answer01.jpg"
                      alt="暂无照片"
                    />
                    <p>多人在线抢答系统</p>
                  </div>
                </Col>
                <Col :xs="11" :sm="11" :lg="0" :xl="0" class="tabs_vr">
                  <div @click="skipSafetyEducation">
                    <img
                      src="../../static/img/Buy/Injury/injury01.jpg"
                      alt="暂无照片"
                    />
                    <p>机械模拟伤害体验</p>
                  </div>
                </Col>
                <Col :xs="11" :sm="11" :lg="0" :xl="0" class="tabs_vr">
                  <div @click="skipSafetyEducation">
                    <img
                      src="../../static/img/Buy/Electric/Electric01.jpg"
                      alt="暂无照片"
                    />
                    <p>电焊实操模拟体验</p>
                  </div>
                </Col>
              </Row>
            </TabPane>
            <TabPane label="智能测量工具">
              <Row justify="center" type="flex">
                <Col :xs="11" :sm="11" :lg="0" :xl="0" class="tabs_vr">
                  <div @click="skipHuiTan">
                    <img
                      src="../../static/img/photo/photo_huitan.jpg"
                      alt="暂无照片"
                    />
                    <p>智能回弹仪</p>
                  </div>
                </Col>
                <Col :xs="11" :sm="11" :lg="0" :xl="0" class="tabs_vr">
                  <div @click="skipRule">
                    <img
                      src="../../static/img/photo/photo_rule.png"
                      alt="暂无照片"
                    />
                    <p>智能靠尺</p>
                  </div>
                </Col>
                <Col :xs="11" :sm="11" :lg="0" :xl="0" class="tabs_vr">
                  <div @click="skipCeJu">
                    <img
                      src="../../static/img/photo/photo_ceju01.png"
                      alt="暂无照片"
                    />
                    <p>激光测距仪</p>
                  </div>
                </Col>
                <Col :xs="11" :sm="11" :lg="0" :xl="0" class="tabs_vr">
                  <div @click="skipVernierCaliper">
                    <img
                      src="../../static/img/Buy/VernierCaliper/VernierCaliper01.png"
                      alt="暂无照片"
                    />
                    <p>游标卡尺</p>
                  </div>
                </Col>
              </Row>
            </TabPane>
            <TabPane label="智慧投影">
              <Row justify="start" type="flex">
                <Col :xs="11" :sm="11" :lg="0" :xl="0" class="tabs_vr">
                  <div @click="skipInteraction">
                    <img
                      src="../../static/img/Content/SlideScreen/SlideScreen01.png"
                      alt="暂无照片"
                    />
                    <p>智慧投影</p>
                  </div>
                </Col>
              </Row>
            </TabPane>
          </Tabs>
        </Col>
        <!-- <Col :xs="15" :sm="15" :lg="0" :xl="0">
          <Carousel v-model="CarouselVal1" @on-change="getCarouselVal1">
            <CarouselItem>
              <div>
                <i-video style="z-index: 1"></i-video>
              </div>
            </CarouselItem>
            <CarouselItem>
              <div class="my-Video">
                <div class="my_video">
                  <video-player
                    class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions"
                  >
                  </video-player>
                </div>
              </div>
            </CarouselItem>
          </Carousel>
        </Col> -->
      </Row>
    </div>
    <!--合作伙伴-->
    <div class="friend_div">
      <Row justify="center" type="flex">
        <Col :xs="24" :lg="15" :xl="15">
          <div style="margin-top: 40px">
            <div class="product_div01">合作伙伴</div>
            <div class="product_div02">Cooperative Partner</div>
          </div>
          <Row justify="start" type="flex">
            <Col
              :xs="8"
              :lg="6"
              :xl="6"
              v-for="(item, index) in imgSrc"
              :key="index"
              style="margin: 20px 0 40px 0"
            >
              <div style="width: 100%; height: 100%; text-align: center">
                <img
                  style="width: 160px; height: 135px"
                  :src="item.url"
                  alt="暂无照片"
                />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
    <!--公司简介-->
    <div style="background: #ffffff">
      <Row justify="center" type="flex">
        <Col span="15">
          <div style="margin-top: 40px">
            <div class="product_div01">关于我们</div>
          </div>
        </Col>
      </Row>
      <Row type="flex" justify="center">
        <Col :xs="24" :lg="24" :xl="24">
          <Row justify="center" type="flex" style="margin: 30px 0">
            <Col :xs="0" :sm="0" :md="0" :lg="7" :xl="7" offset="1">
              <img
                style="width: 100%; height: 100%"
                src="../../static/img/Content/timg02.jpg"
                alt="暂无照片"
              />
            </Col>
            <Col
              :xs="{ span: 24 }"
              :md="24"
              :sm="24"
              :lg="8"
              :xl="8"
              style="
                display: grid;
                justify-content: center;
                align-content: center;
              "
            >
              <div class="profile_profile">
                <div class="product_div03">公司简介</div>
                <p style="width: 98%">
                  河南南秀数智科技有限公司旨在为建筑行业提供专业的VR技术服务、AR技术服务，建筑数据信息化服务等。公司地处郑州市郑东新区，地理位置优越，交通便利。
                  公司内部拥有精通VR、AR、互动操作台、智能机器人、电子沙盘、建筑数据信息化&nbsp;
                  平台等相关技术各项应用的高端技术人才团队，为您提供完整的三维可视化解决方案，体验震撼的虚拟现实环境、触摸操作三维景观，体验多种建筑智
                  能化设备硬件产品。主要经营范围：VR\AR技术应用、
                  计算机系统集成，建筑 工地安全管理平台,云平台管理...
                </p>
                <div class="profile_profileDiv" @click="getLocal">详情>></div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import Video from "./Video";
import WisdomSite from "./WisdomSite";
export default {
  name: "Content",
  components: {
    Video,
    "i-video": Video,
  },
  data() {
    return {
      // VR/MR
      photoArr1: [
        {
          photoUrl: "../../../static/img/Content/WisdomSite/Eggchair.jpg",
          photoUrl1: "../../../static/img/Content/WisdomSite/Eggchair.jpg",
          Img: ["../../../static/img/Content/WisdomSite/Eggchair.jpg"],
          ref: "VR蛋椅体验",
          money: "￥30000.00",
          classify: [
            {
              type: "",
              money: "￥30000.00",
              img: "../../../static/img/Content/WisdomSite/wisdomSite06.png",
            },
          ],
          title: "VR蛋椅体验",
          belong: "VR蛋椅体验",
          path: "/home/Buy/BuyWisdomSite",
        },
        {
          photoUrl: "../../../static/img/Content/WisdomSite/drug.webp",
          photoUrl1: "../../../static/img/Content/WisdomSite/drug.webp",
          Img: ["../../../static/img/Content/WisdomSite/drug.webp"],
          ref: "VR禁毒体验",
          money: "",
          classify: [
            {
              type: "",
              money: "",
              img: "../../../static/img/Content/WisdomSite/drug.webp",
            },
          ],
          title: "VR禁毒体验",
          belong: "VR禁毒体验",
          path: "/home/Buy/BuyWisdomSite",
        },
        {
          photoUrl: "../../../static/img/Content/WisdomSite/Theparty.jpg",
          photoUrl1: "../../../static/img/Content/WisdomSite/Theparty.jpg",
          Img: ["../../../static/img/Content/WisdomSite/Theparty.jpg"],
          ref: "VR党建",
          money: "",
          classify: [
            {
              type: "",
              money: "",
              img: "../../../static/img/Content/WisdomSite/Theparty.jpg",
            },
          ],
          title: "VR党建",
          belong: "VR党建",
          path: "/home/Buy/BuyWisdomSite",
        },
        {
          photoUrl: "../../../static/img/Content/WisdomSite/VR消防安全体验.png",
          photoUrl1:
            "../../../static/img/Content/WisdomSite/VR消防安全体验.png",
          Img: ["../../../static/img/Content/WisdomSite/VR消防安全体验.png"],
          ref: "VR消防安全体验",
          money: "",
          classify: [
            {
              type: "",
              money: "",
              img: "../../../static/img/Content/WisdomSite/VR消防安全体验.png",
            },
          ],
          title: "VR消防安全体验",
          belong: "VR消防安全体验",
          path: "/home/Buy/BuyWisdomSite",
        },
      ],
      // 智慧消防区
      photoArr2: [
        {
          photoUrl:
            "../../../static/img/Content/WisdomProjection/虚拟灭火演练系统.png",
          photoUrl1:
            "../../../static/img/Content/WisdomProjection/虚拟灭火演练系统.png",
          p: "本系统集虚拟现实、系统仿真、声音仿真、人机交互等前沿技术于一体，高逼真模拟众多火灾场景，为使用人员提供身临其境的消防演练环境，操作过程中无真实明火等安全隐患，不受场地限制，可轻松满足大规模消防演练需求，充分提高训练效率，全面提升训练质量，极大节约使用成本。",
          VRImg: [
            "../../../static/img/Content/WisdomProjection/虚拟灭火演练系统.png",
          ],
          ref: "虚拟灭火演练系统",
          money: "¥22000.00-¥36000.00",
          classify: [],
          title: "虚拟灭火演练系统",
          belong: "虚拟灭火演练系统",
          path: "/home/Buy/SlideScreen",
        },
        // 消防知识问答
        {
          photoUrl:
            "../../../static/img/Content/WisdomProjection/消防知识问答系统.png",
          photoUrl1:
            "../../../static/img/Content/WisdomProjection/消防知识问答系统.png",
          p: "消防知识问答系统中包含全面丰富的消防知识，可通过后台管理程序进行实时更新，设备自主进行问答、评分，通过人机交互自动问答模式，加强体验者的消防知识记忆。",
          VRImg: [
            "../../../static/img/Content/WisdomProjection/消防知识问答系统.png",
          ],
          ref: "消防知识问答",
          money: "",
          classify: [],
          title: "消防知识问答",
          belong: "消防知识问答",
          path: "/home/Buy/SlideScreen",
        },
        // 消防逃生
        {
          photoUrl:
            "../../../static/img/Content/WisdomProjection/消防逃生体验.png",
          photoUrl1:
            "../../../static/img/Content/WisdomProjection/消防逃生体验.png",
          p: "消防逃生体验设备可以作为消防逃生演习的体验设备。系统会根据逃生过程中体验者的表现进行打分,用来反映体验者对消防逃生知识的掌握程度。通过这款消防逃生体验设备可以增强作业人员在施工作业时对于火灾的安全防护意识提高作业人员火灾逃生的生还几率。",
          VRImg: [
            "../../../static/img/Content/WisdomProjection/消防逃生体验.png",
          ],
          ref: "消防逃生体验",
          money: "",
          classify: [],
          title: "消防逃生体验",
          belong: "消防逃生体验",
          path: "/home/Buy/SlideScreen",
        },
        // 缓降逃生体验系统
        {
          photoUrl:
            "../../../static/img/Content/WisdomProjection/缓降逃生体验系统.png",
          photoUrl1:
            "../../../static/img/Content/WisdomProjection/缓降逃生体验系统.png",
          p: "缓降逃生体验装置系统搭建仿真化场景平台,体验者利用缓降减速器降落至安全地带,通过真实参与体验,学会如何使用缓降器,正确处理突发情况。",
          VRImg: [
            "../../../static/img/Content/WisdomProjection/缓降逃生体验系统.png",
          ],
          ref: "缓降逃生体验系统",
          money: "",
          classify: [],
          title: "缓降逃生体验系统",
          belong: "缓降逃生体验系统",
          path: "/home/Buy/SlideScreen",
        },
        // 消防装备认知系统
        {
          photoUrl:
            "../../../static/img/Content/WisdomProjection/消防装备认知系统.png",
          photoUrl1:
            "../../../static/img/Content/WisdomProjection/消防装备认知系统.png",
          p: "消防装备认知系统综合互动游戏体验与知识学习两大模式,游戏模式为超级大转盘,观众可随意旋转转盘,随机了解一项消防装备。在语音讲解与灯光互动中认知消防装备的功用以及使用场所,从而将所学知识更好的应用与生活。",
          VRImg: [
            "../../../static/img/Content/WisdomProjection/消防装备认知系统.png",
          ],
          ref: "消防装备认知系统",
          money: "",
          classify: [],
          title: "消防装备认知系统",
          belong: "消防装备认知系统",
          path: "/home/Buy/SlideScreen",
        },
        // 119模拟电话报警
        {
          photoUrl:
            "../../../static/img/Content/WisdomProjection/119模拟电话报警.png",
          photoUrl1:
            "../../../static/img/Content/WisdomProjection/119模拟电话报警.png",
          p: "119模拟电话报警体验系统融合了智能语音识别、真人真实对话、三维动画演示等技术,体验者通过拨打119电话与虚拟接警员对话(根据火灾现场图片提取报警信息),学习报警过程中各类知识要点。同时还可选择观看到各类爆笑报警视频画面以及报警流程的动画演示等。",
          VRImg: [
            "../../../static/img/Content/WisdomProjection/119模拟电话报警.png",
          ],
          ref: "119模拟电话报警",
          money: "",
          classify: [],
          title: "119模拟电话报警",
          belong: "119模拟电话报警",
          path: "/home/Buy/SlideScreen",
        },
        // 超级消防员体感游戏
        {
          photoUrl:
            "../../../static/img/Content/WisdomProjection/超级消防员体感游戏.png",
          photoUrl1:
            "../../../static/img/Content/WisdomProjection/超级消防员体感游戏.png",
          p: "超级消防员体感游戏是开发的新型体感电子游戏,体验者通过界面提示,参与灭火救援活动,达到了解灾情、克服恐惧的目的。",
          VRImg: [
            "../../../static/img/Content/WisdomProjection/超级消防员体感游戏.png",
          ],
          ref: "超级消防员体感游戏",
          money: "",
          classify: [],
          title: "超级消防员体感游戏",
          belong: "超级消防员体感游戏",
          path: "/home/Buy/SlideScreen",
        },
        // 电梯逃生知识学习系统
        {
          photoUrl:
            "../../../static/img/Content/WisdomProjection/电梯逃生知识学习系统.png",
          photoUrl1:
            "../../../static/img/Content/WisdomProjection/电梯逃生知识学习系统.png",
          p: "电梯事故逃生自救演示系统利用三维计算图形技术,绘制高仿展示视频,体验者按视频展示,进行逃生与自救方式选择,程序针对体验者选择是否正确,计算机出程序运行方向。通过人机互交帮助体验者掌握正确的电梯逃生方法。",
          VRImg: [
            "../../../static/img/Content/WisdomProjection/电梯逃生知识学习系统.png",
          ],
          ref: "电梯逃生知识学习系统",
          money: "",
          classify: [],
          title: "电梯逃生知识学习系统",
          belong: "电梯逃生知识学习系统",
          path: "/home/Buy/SlideScreen",
        },
        // 缓降逃生体验系统
        {
          photoUrl:
            "../../../static/img/Content/WisdomProjection/缓降逃生体验系统.png",
          photoUrl1:
            "../../../static/img/Content/WisdomProjection/缓降逃生体验系统.png",
          p: "缓降逃生体验装置系统搭建仿真化场景平台,体验者利用缓降减速器降落至安全地带,通过真实参与体验,学会如何使用缓降器,正确处理突发情况。",
          VRImg: [
            "../../../static/img/Content/WisdomProjection/缓降逃生体验系统.png",
          ],
          ref: "缓降逃生体验系统",
          money: "",
          classify: [],
          title: "缓降逃生体验系统",
          belong: "缓降逃生体验系统",
          path: "/home/Buy/SlideScreen",
        },
        // 火灾案例警示
        {
          photoUrl:
            "../../../static/img/Content/WisdomProjection/火灾案例警示.png",
          photoUrl1:
            "../../../static/img/Content/WisdomProjection/火灾案例警示.png",
          p: "",
          VRImg: [
            "../../../static/img/Content/WisdomProjection/火灾案例警示.png",
          ],
          ref: "火灾案例警示",
          money:
            "真实火灾案例分析8G，预防火灾再次发生的有效方法，警醒世人提高警惕，防范于未然。根据当地实际情况编辑视频教育素材。",
          classify: [],
          title: "火灾案例警示",
          belong: "火灾案例警示",
          path: "/home/Buy/SlideScreen",
        },
        // 火灾成因体验
        {
          photoUrl:
            "../../../static/img/Content/WisdomProjection/火灾成因体验.png",
          photoUrl1:
            "../../../static/img/Content/WisdomProjection/火灾成因体验.png",
          p: "火灾成因演示实验台模拟还原了不同因素引起的火灾场景,由讲解员进行操作演示并讲解各类火灾形成的原因,通过实际现象有助于体验者了解电气安全,避免电气火灾的发生。",
          VRImg: [
            "../../../static/img/Content/WisdomProjection/火灾成因体验.png",
          ],
          ref: "火灾成因体验",
          money: "",
          classify: [],
          title: "火灾成因体验",
          belong: "火灾成因体验",
          path: "/home/Buy/SlideScreen",
        },
        // 建筑消防设施联动演示系统
        {
          photoUrl:
            "../../../static/img/Content/WisdomProjection/建筑消防设施联动演示系统.png",
          photoUrl1:
            "../../../static/img/Content/WisdomProjection/建筑消防设施联动演示系统.png",
          p: "联动演示系统以灯光形式,展示了联动设施的运作过程及原理,包括从发生火灾开始到火灾被完全扑灭。体验者还可以通过按下手动报警按钮,实现手动触发联动设施运作。通过展示了解联动设施的工作原理与使用方法。",
          VRImg: [
            "../../../static/img/Content/WisdomProjection/建筑消防设施联动演示系统.png",
          ],
          ref: "建筑消防设施联动演示系统",
          money: "",
          classify: [],
          title: "建筑消防设施联动演示系统",
          belong: "建筑消防设施联动演示系统",
          path: "/home/Buy/SlideScreen",
        },
        // 结绳自救学习系统
        {
          photoUrl:
            "../../../static/img/Content/WisdomProjection/结绳自救学习系统.png",
          photoUrl1:
            "../../../static/img/Content/WisdomProjection/结绳自救学习系统.png",
          p: "结绳自救演示系统设置了逃生过程中10种自救结绳打法的视频、图片，并配有详细的结绳方法讲解，体验者通过观看视频和步骤图片，了解并学会结绳的各种打法、使用方式，掌握结绳要领。",
          VRImg: [
            "../../../static/img/Content/WisdomProjection/结绳自救学习系统.png",
          ],
          ref: "结绳自救学习系统",
          money: "",
          classify: [],
          title: "结绳自救学习系统",
          belong: "结绳自救学习系统",
          path: "/home/Buy/SlideScreen",
        },
        // 跨步电压+用电救助体验
        {
          photoUrl:
            "../../../static/img/Content/WisdomProjection/跨步电压+用电救助体验.png",
          photoUrl1:
            "../../../static/img/Content/WisdomProjection/跨步电压+用电救助体验.png",
          p: "仿真跨步电压环境,让体验者认知跨步电压带来的触电伤害,使其充分了解跨步电压的危害,并使用视频教学的方法,学习在跨步电压环境下如何正确自救的方法。",
          VRImg: [
            "../../../static/img/Content/WisdomProjection/跨步电压+用电救助体验.png",
          ],
          ref: "跨步电压+用电救助体验",
          money: "",
          classify: [],
          title: "跨步电压+用电救助体验",
          belong: "跨步电压+用电救助体验",
          path: "/home/Buy/SlideScreen",
        },
        // 楼宇火灾自动报警
        {
          photoUrl:
            "../../../static/img/Content/WisdomProjection/楼宇火灾自动报警.png",
          photoUrl1:
            "../../../static/img/Content/WisdomProjection/楼宇火灾自动报警.png",
          p: "楼宇火灾自动报警以灯光形式,展示了联动设施的运作过程及原理,包括从发生火灾开始到火灾被完全扑灭。体验者还可以通过按下手动报警按钮,实现手动触发联动设施运作。通过展示了解联动设施的工作原理与使用方法。",
          VRImg: [
            "../../../static/img/Content/WisdomProjection/楼宇火灾自动报警.png",
          ],
          ref: "楼宇火灾自动报警",
          money: "",
          classify: [],
          title: "楼宇火灾自动报警",
          belong: "楼宇火灾自动报警",
          path: "/home/Buy/SlideScreen",
        },
        // 模拟3D火灾逃生游戏
        {
          photoUrl:
            "../../../static/img/Content/WisdomProjection/模拟3D火灾逃生游戏.png",
          photoUrl1:
            "../../../static/img/Content/WisdomProjection/模拟3D火灾逃生游戏.png",
          p: "3D模拟火灾逃生游戏,使用虚拟仿真技术还原各建筑场景内的火灾环境,体验者使用3D游戏遥杆,操作系统人物根据火险情况,选择有利物品或制造避难间,在有效时间内进行现场逃生,获得针对性的消防逃生指导。",
          VRImg: [
            "../../../static/img/Content/WisdomProjection/模拟3D火灾逃生游戏.png",
          ],
          ref: "模拟3D火灾逃生游戏",
          money: "",
          classify: [],
          title: "超级消防员体感游戏",
          belong: "超级消防员体感游戏",
          path: "/home/Buy/SlideScreen",
        },
        // 模拟厨房灭火体验系统
        {
          photoUrl:
            "../../../static/img/Content/WisdomProjection/模拟厨房灭火体验系统.png",
          photoUrl1:
            "../../../static/img/Content/WisdomProjection/模拟厨房灭火体验系统.png",
          p: "厨房模拟灭火体验系统还原了厨房油锅起火和煤气泄漏两种虚拟情境,体验者通过观察视频火情内容,选择配置的灭火器、灭火毯、锅盖等仿真实物进行灭火,通过学习可迅速掌握相应的应急厨房灭火措施。",
          VRImg: [
            "../../../static/img/Content/WisdomProjection/模拟厨房灭火体验系统.png",
          ],
          ref: "模拟厨房灭火体验系统",
          money: "",
          classify: [],
          title: "模拟厨房灭火体验系统",
          belong: "模拟厨房灭火体验系统",
          path: "/home/Buy/SlideScreen",
        },
        // 模拟电动车火灾试验台
        {
          photoUrl:
            "../../../static/img/Content/WisdomProjection/模拟电动车火灾试验台.png",
          photoUrl1:
            "../../../static/img/Content/WisdomProjection/模拟电动车火灾试验台.png",
          p: "模拟电动车起火实验台是通过一系列专业实验现象,包含:电动车正常负载时的电压及电流,电动车过载时的电压、电流以及线路烧毁,电动车使用时线路的温度看、电动车电瓶正常时,线路的温度等。使用户可以直观的了解电动车起火的原理,有助于正确的使用电动车以及安全充电,避免电路火灾的发生。",
          VRImg: [
            "../../../static/img/Content/WisdomProjection/模拟电动车火灾试验台.png",
          ],
          ref: "模拟电动车火灾试验台",
          money: "",
          classify: [],
          title: "模拟电动车火灾试验台",
          belong: "模拟电动车火灾试验台",
          path: "/home/Buy/SlideScreen",
        },
        // 模拟粉尘爆炸实验台
        {
          photoUrl:
            "../../../static/img/Content/WisdomProjection/模拟粉尘爆炸实验台.png",
          photoUrl1:
            "../../../static/img/Content/WisdomProjection/模拟粉尘爆炸实验台.png",
          p: "粉尘爆炸实验台是一款一体化的实验装置,内有自动点火装置和风力扬尘系统,人工添加粉尘面粉等,扬尘开始后,点火将会发生粉尘爆炸,整个实验范围仅限筒壁内部,观众可以清晰地看到爆炸过程,实验具有一定的危险性,需要在专业人员的指导下进行操作。",
          VRImg: [
            "../../../static/img/Content/WisdomProjection/模拟粉尘爆炸实验台.png",
          ],
          ref: "模拟粉尘爆炸实验台",
          money: "",
          classify: [],
          title: "模拟粉尘爆炸实验台",
          belong: "模拟粉尘爆炸实验台",
          path: "/home/Buy/SlideScreen",
        },
      ],
      // 智能展示区
      photoArr3: [
        /*智能机器人*/
        {
          photoUrl: "../../../static/img/photo/photo_robot.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_robot.jpg",
          p: "",
          VRImg: [
            // "../../../static/img/Buy/Robot/Robot.jpg",
            // "../../../static/img/Buy/Robot/Robot02.jpg",
            // "../../../static/img/Buy/Robot/Robot03.jpg",
            // "../../../static/img/Buy/Robot/Robot04.jpg",
          ],
          ref: "智能机器人",
          money: "¥38000.00",
          classify: [
            {
              type: "",
              money: "￥38000.00",
              img: "../../../static/img/photo-da/photo_robot.jpg",
            },
          ],
          title: "安全教育",
          belong: "智能机器人",
          path: "/home/Buy/SafetyEducation",
        },
        // 电子沙盘
        {
          photoUrl: "../../../static/img/Content/ElectronicSand table.png",
          photoUrl1:
            "../../../static/img/Content/Interaction/Interaction02.jpg",
          p: "",
          VRImg: [
            "../../../static/img/Buy/Interaction/in01.png",
            "../../../static/img/Content/Interaction/Interaction02.jpg",
            "../../../static/img/Buy/Interaction/in03.png",
            "../../../static/img/Buy/Interaction/in04.png",
            "../../../static/img/Buy/Interaction/in05.png",
          ],
          ref: "互动台电子沙盘",
          money: "¥22000.00-￥36000.00",
          classify: [
            {
              type: "互动台电子沙盘（硬件部分）",
              money: "￥36000.00",
              img: "../../../static/img/photo-da/photo_dangjian.png",
            },
            {
              type: "模型设计（软件部分 定制）",
              money: "￥22000.00",
              img: "../../../static/img/photo-da/photo_dangjian.png",
            },
            {
              type: "程序设计（软件部分 定制）",
              money: "￥28000.00",
              img: "../../../static/img/photo-da/photo_dangjian.png",
            },
          ],
          title: "互动台电子沙盘",
          belong: "互动台电子沙盘",
          path: "/home/Buy/Interaction",
        },
        // 滑轨屏
        {
          photoUrl: "../../../static/img/Content/WisdomSlidingscreen.png",
          photoUrl1:
            "../../../static/img/Content/SlideScreen/SlideScreen01.png",
          p:
            "互动滑轨屏又称滑轨电视，形成结构由电子显示屏幕、轨道、红外感应器、主机、电机等组成，显示" +
            "屏可左右上下控制，安装形式多样，电子屏幕移动到预定定位时，将会显示播放对应的素材内容与背景形成" +
            "鲜明呼应，并与观众产生互动。电子显示屏可做多种选择，如OLED透明屏、触控-体机、 拼接屏等不同显示设备,具体可根据客户" +
            "需求定制。互动滑轨屏提供软件功能，可在电子屏幕上根据手指的动作放大.旋转、缩小等。",
          VRImg: [
            "../../../static/img/Content/SlideScreen/SlideScreen01.png",
            "../../../static/img/Content/SlideScreen/SlideScreen02.png",
            "../../../static/img/Content/SlideScreen/SlideScreen03.png",
            "../../../static/img/Content/SlideScreen/SlideScreen04.png",
          ],
          ref: "智慧滑轨屏",
          money: "¥22000.00-¥36000.00",
          classify: [],
          title: "互动滑轨屏",
          belong: "互动滑轨屏",
          path: "/home/Buy/SlideScreen",
        },
        // 全息投影系统
        {
          photoUrl: "../../../static/img/photo/全息投影系统.png",
          photoUrl1: "../../../static/img/photo/全息投影系统.png",
          p: "内置系统，高清展示可通过全息方式3d立体进行展示简洁大方，美观新颖（可定制）",
          VRImg: ["../../../static/img/photo/全息投影系统.png"],
          ref: "全息投影系统",
          money: "",
          classify: [],
          title: "全息投影系统",
          belong: "全息投影系统",
          path: "/home/Buy/SlideScreen",
        },
        // 全息投影系统
        {
          photoUrl: "../../../static/img/photo/全息系统.png",
          photoUrl1: "../../../static/img/photo/全息系统.png",
          p: "低成本便捷全息展示设备可展示视频，图片，动画等内容支持自动生成视频",
          VRImg: ["../../../static/img/photo/全息系统.png"],
          ref: "全息系统",
          money: "",
          classify: [],
          title: "全息系统",
          belong: "全息系统",
          path: "/home/Buy/SlideScreen",
        },
      ],
      /*智能展示区*/
      WisdomProjectionList: [
        "../../static/img/Content/WisdomProjection/wisdomProjection01.jpg",
        "../../static/img/Content/WisdomProjection/wisdomProjection02.jpg",
        "../../static/img/Content/WisdomProjection/wisdomProjection03.jpg",
        "../../static/img/Content/WisdomProjection/wisdomProjection04.jpg",
      ],
      /*智慧党建滑轨屏*/
      WisdomDangList: [],
      //新闻资讯
      ulList: [
        {
          name: "NewsSeven",
          day: "22",
          month: "2022/07",
          title: "热烈欢迎陕西省宝鸡市港务区领导莅临南秀...",
          content:
            "7月22日下午，陕西省宝鸡市港务区调研团队莅临智慧岛大厦及南秀科技参观指导，领导们在四楼听取了创意岛孵化器运营情况。",
        },
        {
          name: "NewsNine",
          day: "10",
          month: "2022/07",
          title: "热烈欢迎内蒙古观摩团莅临南秀...",
          content:
            "7月9日上午，为加快推进智慧岛建设实施意见，高标准推进智慧岛建设，不断提升科技创新能力，内蒙古观摩团到智慧岛大厦",
        },
        {
          name: "NewsSix",
          day: "07",
          month: "2022/07",
          title: "热烈欢迎河南省政协副主席高体建等...",
          content:
            "7月6日，为打造一流创新平台，建设国家创新高地，河南省政协副主席高体建，省政协常委、教科卫体委员会主任胡广坤 ，省政协常委、教科卫体委员会副主任修振环，省政协委员、省科学技术厅党组书记....",
        },
        {
          name: "NewsEight",
          day: "01",
          month: "2022/07",
          title: "热烈欢迎南阳市、驻马店市调研团队莅临...",
          content:
            "为贯彻落实智慧岛建设推进会会议精神，加快推动南阳市和驻马店市智慧岛建设工作，打造双创实际版，7月1日上午，南阳高新区党工委副书记、管委会主任党俊伟和驻马店市发展改革委副主任...",
        },
      ],
      //企业产品
      menuTheme: "light",
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: true, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: false, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 类型
            src: require("../../static/video/公路局VR宣传视频.mp4"), //url地址
          },
        ],
        //poster: require('../../static/img/video/02.jpg'), // 封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
      },
      /*表单*/
      formItem: {
        userName: "",
        email: "",
        phone: "",
        message: "",
        code: "",
      },
      ruleItem: {},
      /*验证码*/
      show_num: [],
      CarouselVal: 0,
      CarouselVal1: 0,
      actAnchor: false,
      /*合作伙伴*/
      imgSrc: [
        { url: "../../static/img/Content/Friend/11.jpg" },
        { url: "../../static/img/Content/Friend/jianzhu01.jpg" },
        { url: "../../static/img/Content/Friend/jianzhu02.jpg" },
        { url: "../../static/img/Content/Friend/jianzhu03.jpg" },
        { url: "../../static/img/Content/Friend/jianzhu04.png" },
        { url: "../../static/img/Content/Friend/jianzhu05.jpg" },
        { url: "../../static/img/Content/Friend/jianzhu07.jpg" },
        { url: "../../static/img/Content/Friend/jianzhu09.jpg" },
        { url: "../../static/img/Content/Friend/jianzhu10.jpg" },
        { url: "../../static/img/Content/Friend/jianzhu11.jpeg" },
        { url: "../../static/img/Content/Friend/jianzhu12.jpg" },
      ],
    };
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    /*获取轮播的index*/
    this.getCarouselVal1();
    /*地图*/
    this.getAdress();
    /*获取验证码*/
    this.getCode();
  },
  methods: {
    /*获取企业产品*/
    clickGetEnterPrise(id) {
      console.log(id);
    },
    /*智慧工地跳转*/
    WisdomSiteMore() {
      this.$router.push({
        name: "WisdomSite",
      });
    },
    /*企业产品更多跳转*/
    getMore() {
      this.$router.push({
        path: "Buy",
      });
    },
    /*新闻资讯的跳转*/
    getSkip(name) {
      this.$router.push({
        name: name,
      });
    },
    /*新闻资讯的跟多*/
    getLocalNews() {
      this.$router.push({
        name: "NewsProfile",
      });
    },
    /*关于我们的详情跳转*/
    getLocal() {
      this.$router.push({
        path: "/home/AboutUs",
      });
    },
    /*播放*/
    autoplay() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.playerOptions.autoplay = scrollTop > 340;
      this.playerOptions.muted = scrollTop > 340;
    },
    /*获取轮播的index*/
    getCarouselVal1(oldValue, value) {
      if (value === 1) {
        this.playerOptions.autoplay = true;
        this.playerOptions.muted = true;
      }
    },
    /*导航菜单点击事件*/
    onMenuSelect: function (name) {
      console.log(name, " is clicked!");
    },
    /*提交*/
    submit() {
      let _this = this;
      let code = _this.formItem.code.toLocaleLowerCase();
      let num = _this.show_num.join("");
      if (_this.formItem.message.trim() === "") {
        _this.$Message.warning("输入编辑信息为空");
      } else if (_this.formItem.phone.trim() === "") {
        _this.$Message.warning("输入电话为空");
      } else if (_this.formItem.email.trim() === "") {
        _this.$Message.warning("输入邮箱为空");
      } else if (_this.formItem.userName.trim() === "") {
        _this.$Message.warning("输入用户名为空");
      } else if (code.trim() === "") {
        _this.$Message.warning("输入验证码为空");
      } else if (code.trim() === num) {
        _this.$Message.success("提交成功");
        _this.formItem.code = "";
      } else {
        _this.$Message.error("提交失败");
        _this.formItem.code = "";
      }
    },
    /*获取验证码*/
    getCode() {
      var show_num = [];
      draw(show_num);
      this.show_num = show_num;
      /*验证码刷新*/
      $("#canvas").on("click", function () {
        draw(show_num);
        this.show_num = show_num;
      });

      //生成并渲染出验证码图形
      function draw(show_num) {
        var canvas_width = $("#canvas").width();
        var canvas_height = $("#canvas").height();
        var canvas = document.getElementById("canvas"); //获取canvas的对象
        var context = canvas.getContext("2d"); //获取canvas画图的环境
        canvas.width = canvas_width;
        canvas.height = canvas_height;
        var sCode =
          "a,b,c,d,e,f,g,h,i,j,k,m,n,p,q,r,s,t,u,v,w,x,y,z,A,B,C,E,F,G,H,J,K,L,M,N,P,Q,R,S,T,W,X,Y,Z,1,2,3,4,5,6,7,8,9,0";
        var aCode = sCode.split(",");
        var aLength = aCode.length; //获取数组长度
        for (let i = 0; i < 4; i++) {
          //这里的for循环可以控制验证码位数
          var j = Math.floor(Math.random() * aLength); //获取随机的索引值
          //var deg = Math.random() * 30 * Math.PI / 180;//产生0~30的随机弧度
          var deg = Math.random() - 0.5;
          var txt = aCode[j];
          show_num[i] = txt.toLocaleLowerCase();
          let x = 10 + i * 20; //文字在canvas的x坐标
          let y = 28 + Math.random() * 8; //文字在canvas的y坐标
          context.font = "bold 23px 微软雅黑";
          context.translate(x, y);
          context.rotate(deg);
          context.fillStyle = randomColor();
          context.fillText(txt, 0, 0);
          context.rotate(-deg);
          context.translate(-x, -y);
        }

        //验证码上显示线条
        for (let i = 0; i <= 5; i++) {
          context.strokeStyle = randomColor();
          context.beginPath();
          context.moveTo(
            Math.random() * canvas_width,
            Math.random() * canvas_height
          );
          context.lineTo(
            Math.random() * canvas_width,
            Math.random() * canvas_height
          );
          context.stroke();
        }

        //验证码上显示小点
        for (let i = 0; i < 30; i++) {
          context.strokeStyle = randomColor();
          context.beginPath();
          let x = Math.random() * canvas_width;
          let y = Math.random() * canvas_height;
          context.moveTo(x, y);
          context.lineTo(x + 1, y + 1);
          context.stroke();
        }
      }

      //得到随机颜色值
      function randomColor() {
        var r = Math.floor(Math.random() * 256);
        var g = Math.floor(Math.random() * 256);
        var b = Math.floor(Math.random() * 256);
        return "rgb(" + r + "," + g + "," + b + ")";
      }
    },
    /*地图*/
    getAdress() {
      // 百度地图API功能
      var map = new BMap.Map("allmap"); // 创建Map实例
      var point = new BMap.Point(113.814123, 34.800619);
      map.centerAndZoom(point, 15); // 初始化地图,设置中心点坐标和地图级别
      //添加地图类型控件
      map.addControl(
        new BMap.MapTypeControl({
          mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP],
        })
      );
      // 创建点标记
      var marker1 = new BMap.Marker(point);
      // 在地图上添加点标记
      map.addOverlay(marker1);
      var opts = {
        width: 200, // 信息窗口宽度
        height: 70, // 信息窗口高度
        title: "智慧岛大厦", // 信息窗口标题
        message: "这里是智慧岛",
      };
      var infoWindow = new BMap.InfoWindow(
        "&nbsp;&nbsp;&nbsp;地址：郑州市郑东新区龙子湖中原数据产业大厦7层",
        opts
      ); // 创建信息窗口对象
      map.openInfoWindow(infoWindow, point); //开启信息窗口
      marker1.addEventListener("click", function () {
        map.openInfoWindow(infoWindow, point); //开启信息窗口
      });
      map.setCurrentCity("郑州"); // 设置地图显示的城市 此项是必须设置的
      //map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
    },
    /*跳转到企业产品的VR安全体验馆*/
    skipVR() {
      this.$router.push({
        path: "/home/Buy/WisdomSite",
      });
    },

    // 消防安全
    getMoney() {
      this.$router.push({
        path: "/home/Buy/Projection",
      });
    },

    // 智慧党建滑轨屏
    SlideScreen() {
      this.$router.push({
        path: "/home/Buy/SlideScreen",
      });
    },
    /*跳转到建筑工程体验馆*/
    skipExperience() {
      this.$router.push({
        path: "/home/Buy/Experience",
      });
    },
    /*跳转到AR质量样板*/
    skipAR() {
      this.$router.push({
        path: "/home/Buy/AR",
      });
    },
    /*跳转到工法质量样板版展示区*/
    skipQuality() {
      this.$router.push({
        path: "/home/Buy/Quality",
      });
    },
    /*工法质量样板展示柜*/
    skipThreeDimensional() {
      this.$router.push({
        path: "/home/Buy/ThreeDimensional",
      });
    },
    /*智能回弹仪*/
    skipHuiTan() {
      this.$router.push({
        path: "/home/Buy/Resiliometer",
      });
    },
    /*智能靠尺*/
    skipRule() {
      this.$router.push({
        path: "/home/Buy/Rule",
      });
    },
    /*激光测距仪*/
    skipCeJu() {
      this.$router.push({
        path: "/home/Buy/Diastimeter",
      });
    },
    /*游标卡尺*/
    skipVernierCaliper() {
      this.$router.push({
        path: "/home/Buy/VernierCaliper",
      });
    },
    /*互动电子沙盘*/
    skipInteraction() {
      this.$router.push({
        path: "/home/Buy/Interaction",
      });
    },
    /*跳转到安全教育*/
    skipSafetyEducation() {
      this.$router.push({
        path: "/home/Buy/SafetyEducation",
      });
    },
  },
};
</script>

<style>
/*联系我们*/
.form_userInput .ivu-input {
  border-top: 1px solid #85b1e2 !important;
  border-right: 1px solid #85b1e2 !important;
  border-bottom: 1px solid #85b1e2 !important;
  border-left: 0 solid transparent;
  height: 52px;
  width: 230px;
  background: #498ad4 !important;
  color: #ffffff !important;
  border-radius: 0;
}

.form_phoneInput .ivu-input {
  border-top: 1px solid #85b1e2 !important;
  border-right: 1px solid #85b1e2 !important;
  border-bottom: 1px solid #85b1e2 !important;
  border-left: 0 solid transparent !important;
  height: 52px;
  width: 520px;
  background: #498ad4 !important;
  color: #ffffff;
  border-radius: 0;
}

.form_codeInput .ivu-input {
  border-top: 1px solid #85b1e2 !important;
  border-right: 0 solid transparent !important;
  border-bottom: 1px solid #85b1e2 !important;
  border-left: 0 solid transparent !important;
  height: 52px;
  width: 420px;
  background: #498ad4 !important;
  color: #ffffff !important;
  border-radius: 0;
}

.form_messageInput .ivu-input {
  margin: 10px 0 0 0;
  border: none;
  width: 496px;
  background: #498ad4 !important;
  color: #ffffff !important;
  border-radius: 0;
}

.form_userInput .ivu-input-group-prepend,
.form_phoneInput .ivu-input-group-prepend,
.form_codeInput .ivu-input-group-prepend {
  background: #498ad4 !important;
  color: #ffffff !important;
  font-size: 31px;
  border-top: 1px solid #85b1e2 !important;
  border-right: 0 solid transparent !important;
  border-bottom: 1px solid #85b1e2 !important;
  border-left: 1px solid #85b1e2 !important;
  border-radius: 0;
}

.form_codeInput .ivu-input-group-append {
  background: #498ad4 !important;
  color: #ffffff !important;
  font-size: 30px;
  border-top: 1px solid #85b1e2 !important;
  border-right: 1px solid #85b1e2 !important;
  border-bottom: 1px solid #85b1e2 !important;
  border-left: 1px solid transparent !important;
}
</style>

<style scoped>
/*智慧工地*/
.WisdomSite_more {
  text-align: center;
  background: #eeeeee;
  transition: background 0.3s ease-in-out;
  -webkit-transition: background 0.3s ease-in-out;
  margin-bottom: 20px;
}

.WisdomSite_more:hover {
  background: #1c75cd;
  color: white;
  cursor: pointer;
}

.WisdomSite_more span {
  display: inline-block;
  width: 100px;
  line-height: 60px;
  font-size: 18px;
}

/*企业产品*/
/* .desktop {
  background-image: url(../../static/img/Content/news.jpg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: top center;
} */
.WisdomSiteContainer_title {
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  font-family: 微软雅黑, serif;
  line-height: 100px;
  color: #000;
}

.WisdomSiteContainer_img {
  margin-top: 2%;
}

.WisdomSiteContainer_img img {
  cursor: pointer;
  transition: all 1s;
}
.WisdomSiteContainer_img img:hover {
  transform: scale(1.1);
}

.row_col_com_div {
  width: 190px;
  height: 80px;
  background-color: #57a3f3;
  text-align: center;
  border-radius: 8px 8px 0 0;
}

.row_col_com_div span {
  color: #ffffff;
  font-size: 26px;
  font-family: 新宋体, serif;
  position: relative;
  top: 30%;
}

/*VR全景*/
.VR_div {
  margin-top: 20px;
  padding-bottom: 14px;
}

/*--------*/
/*关于我们*/
.profile_profile {
  width: 100%;
  background: white;
  padding: 0 0 0 30px;
}

.profile_profileDiv {
  margin-top: 28px;
  cursor: pointer;
  width: 140px;
  height: 40px;
  background: #1c75cd;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  font-size: 15px;
}

.profile_profileDiv:hover {
  background: #0185d0;
}

/*-------*/
/*每个title div的样式*/
.product_div01 {
  font-size: 32px;
  font-family: 微软雅黑, serif;
  text-align: center;
  color: #1f1f1f;
}

.product_div02 {
  font-size: 15px;
  font-family: 微软雅黑, serif;
  text-align: center;
  color: #0185d0;
}

.product_div03 {
  font-size: 26px;
  font-weight: bold;
  font-family: 微软雅黑, serif;
  color: #1b62b7;
  margin-bottom: 22px;
}

.product_div03 + p {
  font-size: 15px;
  line-height: 39px;
  color: #878686;
}

@media screen and (max-width: 567px) {
  .profile_profile {
    height: 1200px;
  }

  .product_div03 + p {
    font-size: 15px;
    line-height: 94px;
    color: #878686;
  }
}

/*左侧菜单*/
.buy_ul ul li {
  cursor: pointer;
  color: #515a6e;
  width: 190px;
  font-size: 16px;
  line-height: 60px;
  padding-left: 10px;
  font-family: 微软雅黑, serif;
  background: linear-gradient(to bottom, #fff, #e5e3e3);
  transition: background 0.15s ease-in-out;
  -webkit-transition: background 0.15s ease-in-out;
  -moz-transition: background 0.15s ease-in-out;
  display: flex;
  display: -webkit-flex;
  place-items: center;
}

.buy_ul ul li:hover {
  background: #209cdc;
  color: white;
}

.buy_ul ul li img {
  margin-right: 6px;
}

/*轮播图的指示器*/
.buy_ul /deep/ .ivu-carousel-dots {
  height: 34px;
}

.buy_ul /deep/ .ivu-carousel-dots li button.radius {
  width: 18px;
  height: 18px;
}

.buy_menu ul {
  background-color: white;
  margin-bottom: 20px;
}

.buy_menu ul a,
.buy_menu ul li {
  width: 190px;
  font-size: 16px;
  font-family: 微软雅黑, serif;
  background-image: linear-gradient(to bottom, #fff, #f7f7f7);
  -webkit-background-image: linear-gradient(to bottom, #fff, #f7f7f7);
}

.buy_menu ul li ul a {
  font-size: 14px;
  background-image: linear-gradient(to bottom, #fff, #f7f7f7);
  -webkit-background-image: linear-gradient(to bottom, #fff, #f7f7f7);
}

.buy_menu ul a img,
.buy_menu ul li img {
  position: relative;
  top: 2px;
  margin-left: -14px;
}

/*右边的视频上方*/
.icon_div {
  width: 94%;
  height: 41px;
  border-radius: 8px 8px;
  background: #fdfdfd;
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-bottom: 14px;
}

.icon_div_more {
  position: relative;
  top: 10px;
  left: 20px;
}

.icon_div_more:hover {
  color: #1296db;
  cursor: pointer;
}

/*验证码*/
#canvas {
  vertical-align: middle;
  box-sizing: border-box;
  border: 1px solid #ddd;
  cursor: pointer;
  background: #e9e0cc;
}

/*提交*/
#btn {
  height: 42px;
  width: 120px;
  font-size: 16px;
  color: #fff;
  background-image: linear-gradient(to right, #1b1bc4, #cf1818);
  border: none;
  border-radius: 50px;
}

/*------------地图-------------------------*/

#allmap {
  position: relative;
  width: 592px;
  height: 610px;
  margin: 0 auto;
}

/*  ----------------------------------------*/
/*-----------------*/
.LunContent {
  background: #ffffff;
}

.LunContent img {
  width: 100%;
  height: 900px;
}

/*--------------*/
/*-----合作伙伴-----*/
.friend_div {
  width: 100%;
  background: url("../../static/img/Content/下载.png") #5286c2 no-repeat;
}

/*-------------------*/
/*--------新闻资讯----------*/
.news_div {
  /* background: url("../../static/img/Content/news.jpg") no-repeat; */
  background-size: 100% 100%;
  background-color: #fff;
}

.news_more {
  width: 100%;
  height: 80px;
}

.news_ul ul li {
  float: left;
  width: 48%;
  margin-top: 20px;
  margin-left: 1%;
  background: #f6f6f6;
}

.news_ul ul li:hover {
  background: #1b62b7;
  color: #ffffff;
}

.news_ul_div {
  display: flex;
}

.news_ul_li_div {
  width: 100px;
  height: 100%;
  text-align: center;
  color: #999999;
  padding-top: 25px;
}

.news_ul_li_div p {
  font-size: 46px;
}
/*  */
.news_ul_li_div span {
  font-size: 20px;
}

.news_ul_li_div01 {
  width: 80%;
  height: 150px;
}

.news_ul_li_div01 p {
  font-size: 22px;
  line-height: 40px;
  margin-top: 18px;
}

.news_hr {
  cursor: pointer;
  width: 20%;
  height: 64px;
  background: white;
  position: relative;
  top: 30px;
  margin: 0 auto;
  text-align: center;
  transition: background 0.3s ease-in-out;
  -webkit-transition: background 0.3s ease-in-out;
  background-color: #eeeeee;
}

.news_hr:hover {
  background: #1c75cd;
  color: white;
}

.news_hr span {
  font-size: 20px;
  line-height: 64px;
}

.news_hover {
  cursor: pointer;
  background: #eeeeee;
  transition: background 0.3s ease-in-out;
  -webkit-transition: background 0.3s ease-in-out;
  margin: 20px 20px;
  border-radius: 5px;
}

.news_hover:hover {
  background: #1b62b7;
  color: #ffffff;
}

/*--------------------------*/
/*----------标签页-----------*/

.tabs {
  margin-bottom: 30px;
}

.tabs /deep/ .ivu-tabs-nav .ivu-tabs-tab {
  font-size: 22px;
  padding: 0 14px 8px 14px;
}

.tabs /deep/ .ivu-tabs-nav-next i:before,
.tabs /deep/ .ivu-tabs-nav-prev i:before {
  font-size: 22px;
}

.tabs_vr {
  background: #f0f0f0;
  text-align: center;
  margin: 20px 0 0 20px;
}

.tabs_vr img {
  width: 240px;
  height: 180px;
  margin-top: 10px;
}

.tabs_vr p {
  font-size: 20px;
  line-height: 50px;
}

/*--------------------------*/
/* 智能测量 */
/*弹出框字体*/
.header_div {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

.font_size {
  font-size: 19px;
}

.buy_col01 {
  width: 270px;
  background: #f7f7f7;
  text-align: center;
  cursor: pointer;
  margin: 14px 14px 0 0;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.1);
  margin-left: 5%;
}

.buy_col01:hover {
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
  color: #5385d0;
}

/* .buy_col01 .sp:hover {
} */

.buy_rule {
  width: 270px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buy_rule img {
  width: 210px;
  height: 210px;
}

.sp {
  font-size: 14px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Content.vue